module.exports = __webpack_public_path__ + "static/podium-1200-600-b7a9082417eb9eff58a60a96e8113e91.png";